import React, {
  createContext,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import DispatchMeRoute from "./components/DispatchMeRoute";
import { routes } from "./routes";
import { BrowserRouter, Link, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { firebaseConnect } from "react-redux-firebase";
import { setUserInfos, setUserInfosJwt } from "./store/actions/authActions";
import { db } from "./index";
import "./App.css";
import "./assets/css/styles.css";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { SearchProvider } from "./components/contexts/SearchContext";
import styled from "styled-components";
import { getSubscriptionInfos } from "./utils/subscription";
import { useLoader } from "./utils/loader";
import { isTotpEnabled, isTotpValidated } from "./utils/account";
import { getMyUserInfos } from "./utils/users";

export const UserContext = createContext({
  user: null,
  userInfos: null,
  loading: true,
});


function App({ firebase, setUserInfosRx, setUserInfosJwtRx }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userInfos, setUserInfos] = useState({});
  const [voiceflowReady, setVoiceflowReady] = useState(false);
  const [pendingInit, setPendingInit] = useState(false);
  const [authToken, setAuthToken] = useState(null);

  const loaderShow = useLoader();
  const voiceflowScriptLoaded = useRef(false);
    console.log('window.location.hostname', window.location.origin)
  const backendUrl =
    window.location.origin === "https://zeplanai.web.app"
      ? "https://zeplanai.web.app"
      : "https://app.zeplan.ai";

  console.log('backendUrl', backendUrl)

  const refreshTokenIntervalId = useRef(null);

  useEffect(() => {
    firebase.auth().onAuthStateChanged((newUser) => {
      setLoading(true);
      setUser(newUser);

      if (newUser) {
        db.ref("users/" + newUser.uid + "/info").on("value", (snapshot) => {
          newUser.getIdToken(true).then(async (token) => {
            localStorage.setItem("token", token);

            let newUserInfos = {};
            try {
              newUserInfos = await getMyUserInfos(token, newUser.uid);
            } catch (e) {
              newUserInfos = snapshot.exists() ? snapshot.val() : {};
            }

            // Trick to use creator space
            newUserInfos.realUid = newUser.uid;
            newUserInfos.uid = newUser.uid;
            if (newUserInfos.createdBy) {
              newUserInfos.uid = newUserInfos.createdBy;
            }

            const subscriptionInfos = await getSubscriptionInfos(token);
            await isTotpValidated(token);
            const _isTotpEnabled = await isTotpEnabled(token);

            newUserInfos = {
              ...newUserInfos,
              jwt: token,
              subscriptionInfos,
              isTotpEnabled: _isTotpEnabled,
            };

            setAuthToken(token);

            // initChatbot(token);

            setUserInfosRx(newUserInfos);
            setUserInfos(newUserInfos);
            setLoading(false);
          });
        });
      } else {
        // cleanChatbot();
        setUserInfos(null);
        setUserInfosRx(null);
        setLoading(false);
      }
    });
  }, [firebase, setUserInfosRx, voiceflowReady]);

  const updateUserInfosJwt = useCallback(
    (newJwt) => {
      setUserInfos((old) => ({
        ...old,
        jwt: newJwt,
      }));

      setUserInfosJwtRx(newJwt);
    },
    [setUserInfosJwtRx]
  );

  useEffect(() => {
    refreshTokenIntervalId.current = setInterval(async () => {
      const currentUser = firebase.auth().currentUser;
      if (currentUser) {
        const newJwt = await currentUser.getIdToken(true);
        updateUserInfosJwt(newJwt);
      }
    }, 15 * 60 * 1000);

    return () => {
      clearInterval(refreshTokenIntervalId.current);
    };
  }, [firebase, updateUserInfosJwt]);

  const SubscriptionBanner = () => {
    if (
      userInfos &&
      userInfos.subscriptionInfos &&
      userInfos?.subscription?.status !== "active"
    ) {
      if (userInfos.subscriptionInfos.tryPeriodAvailable) {
        return (
          <TrialBannerContainer>
            Votre période d'essai se termine dans{" "}
            {userInfos.subscriptionInfos.trialRemainingDays} jours.{" "}
            {/*<Link to="/subscription">Cliquez ici pour vous abonner</Link>*/}
            {userInfos.createdBy ? "Seul votre administrateur peut gérer l'abonnement." : <Link to="/subscription">Cliquez ici pour vous abonner</Link>}
          </TrialBannerContainer>
        );
      } else {
        return (
          <TrialBannerContainer>
            Vous devez vous abonner pour continuer à utiliser l'application.{" "}
            {/*<Link to="/subscription">Cliquez ici pour vous abonner</Link>*/}
            {userInfos.createdBy ? "Seul votre administrateur peut gérer l'abonnement." : <Link to="/subscription">Cliquez ici pour vous abonner</Link>}
          </TrialBannerContainer>
        );
      }
    }
    return null;
  };

  useEffect(() => {
    if (!voiceflowScriptLoaded.current) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://cdn.voiceflow.com/widget-next/bundle.mjs';
      script.async = true;
      script.onload = () => {
        voiceflowScriptLoaded.current = true;
        // Optionally, you can trigger widget init here if token is available
      };
      document.body.appendChild(script);
    }
  }, []);


  useEffect(() => {
    // Inject the script only once
    if (!window.voiceflow) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://cdn.voiceflow.com/widget-next/bundle.mjs';
      script.async = true;
      script.onload = () => setVoiceflowReady(true);
      document.body.appendChild(script);
    } else {
      setVoiceflowReady(true);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const validToken = authToken ? authToken : token;

    if (voiceflowReady && token && window.voiceflow?.chat?.load) {
      if (window.voiceflow.chat.close) {
        window.voiceflow.chat.close();
      }

      window.voiceflow.chat.load({
        verify: { projectID: '6751b5a5cf20302ac919faf4' },
        versionID: 'production',
        assistant: {
          stylesheet: "data:text/css;base64,LmY2ZG9mODEgewogICAgYmFja2dyb3VuZDogYmxhY2sgIWltcG9ydGFudDsKfQoKLmY2ZG9mODE6aG92ZXIgewogICAgYmFja2dyb3VuZDogYmxhY2sgIWltcG9ydGFudDsKfQoKLnZmcmMtbGF1bmNoZXIgewogICAgYmFja2dyb3VuZDogYmxhY2sgIWltcG9ydGFudDsKfQo="
        },
        url: 'https://general-runtime.voiceflow.com',
        userID: Math.random().toString(36).substring(2),
        session: { new: true, ttl: 0 },
        launch: {
          event: {
            type: 'launch',
            payload: { token: validToken, baseUrl: backendUrl },
          },
        },
      }).then(() => {
        // Clear previous proactive messages
        window.voiceflow.chat.proactive.clear();

        // Add custom Zeplan messages
      });

      setPendingInit(false);
    } else if (token && !voiceflowReady) {
      setPendingInit(true); // wait for script to be ready
    }

    if (voiceflowReady && !token && window.voiceflow?.chat?.close) {
      window.voiceflow.chat.close();
    }
  }, [voiceflowReady, user, authToken, backendUrl]);





  // This effect will run when the script finally loads, and pendingInit is true
  useEffect(() => {
    const token = localStorage.getItem('token');
    const validToken = authToken ? authToken : token;
    if (pendingInit && voiceflowReady && token && window.voiceflow?.chat?.load) {
      if (window.voiceflow.chat.close) {
        window.voiceflow.chat.close();
      }
      window.voiceflow.chat.load({
        verify: { projectID: '6751b5a5cf20302ac919faf4' },
        versionID: 'production',
        assistant: {
          stylesheet: "data:text/css;base64,LmY2ZG9mODEgewogICAgYmFja2dyb3VuZDogYmxhY2sgIWltcG9ydGFudDsKfQoKLmY2ZG9mODE6aG92ZXIgewogICAgYmFja2dyb3VuZDogYmxhY2sgIWltcG9ydGFudDsKfQoKLnZmcmMtbGF1bmNoZXIgewogICAgYmFja2dyb3VuZDogYmxhY2sgIWltcG9ydGFudDsKfQo="
        },
        url: 'https://general-runtime.voiceflow.com',
        userID: Math.random().toString(36).substring(2),
        session: { new: true, ttl: 0 },
        launch: {
          event: {
            type: 'launch',
            payload: { token: validToken, baseUrl: backendUrl },
          },
        },
      });
      setPendingInit(false);
    }
  }, [voiceflowReady, pendingInit, authToken, backendUrl]);
  return (
    <UserContext.Provider value={{ user, loading, userInfos }}>
      <BrowserRouter>
        <SearchProvider>
          <SubscriptionBanner />
          <Switch>
            {routes.map((route, routeIndex) => (
              <DispatchMeRoute
                key={route.path + "-" + routeIndex}
                isPublic={route.isPublic}
                driverApp={route.driverApp}
                roles={route.roles}
                component={route.component}
                driverComponent={route.driverComponent}
                prevPath={route.prevPath}
                path={route.path}
                subscriptionFree={route.subscriptionFree}
                object={route?.object}
                objects={route?.objects}
                actions={route?.actions}
                adminOnly={route?.adminOnly}
                exact
              />
            ))}
          </Switch>
          {loading || loaderShow ? (
            <div className="lds-container">
              <div className="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : null}
        </SearchProvider>
      </BrowserRouter>
    </UserContext.Provider>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setUserInfosRx: (data) => dispatch(setUserInfos(data)),
    setUserInfosJwtRx: (data) => dispatch(setUserInfosJwt(data)),
  };
};

export default compose(
  firebaseConnect(),
  connect(() => ({}), mapDispatchToProps)
)(App);

const TrialBannerContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 2em;
  background-color: var(--bs-primary);
  color: white;
  font-size: 1rem;
  text-align: center;
  z-index: 1000;
  padding: 0.2rem 1rem;
  
  a {
    color: white;
    font-weight: bold;
    text-decoration: underline;
  }
`;
